;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:native-teams-frontend":true});}catch(e){}}();import type React from 'react';

interface DinersIconProps extends React.SVGProps<SVGSVGElement> {
  size?: number;
}

export function DinersIcon({ size = 24, ...props }: DinersIconProps) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M9.17161 13.5083C12.1734 13.5227 14.9133 11.0546 14.9133 8.05198C14.9133 4.7685 12.1734 2.49891 9.17161 2.5H6.58818C3.55039 2.49891 1.04999 4.76917 1.04999 8.05198C1.04999 11.0552 3.55039 13.5227 6.58818 13.5083H9.17161Z"
        fill="#0079BE"
      />
      <path
        d="M6.60015 2.95447C3.82429 2.95534 1.57493 5.21051 1.57428 7.99384C1.57493 10.7767 3.82427 13.0316 6.60015 13.0325C9.37665 13.0316 11.6265 10.7767 11.6269 7.99384C11.6264 5.21051 9.37665 2.95534 6.60015 2.95447ZM3.41439 7.99384C3.417 6.63375 4.26449 5.47395 5.45956 5.01306V10.9739C4.26449 10.5133 3.41698 9.35413 3.41439 7.99384ZM7.7403 10.9752V5.01287C8.9358 5.47264 9.78459 6.63309 9.78677 7.99384C9.78459 9.355 8.9358 10.5146 7.7403 10.9752Z"
        fill="white"
      />
    </svg>
  );
}
